import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { SidebarType, SidebarState } from "@/views/sidebar/sidebar.types";

@Module({ namespaced: true })
class SidebarModule extends VuexModule {
  private _type: SidebarState["type"] = SidebarType.None;
  private _item?: SidebarState["item"] = {};
  private _title?: SidebarState["title"] = "";
  private _options?: SidebarState["options"] = {};
  private _history: SidebarState[] = [];
  private _snapshotDisabled = false;
  private _size? = "";
  
  @Mutation
  setSidebarState(state: SidebarState) {
    this._type = state.type;
    this._item = state.item;
    this._title = state.title;
    this._options = state.options;
    this._size = state.size;

    if ((state.useHistory || this._history.length) && state.type !== SidebarType.None) {
      const idx = this._history.findIndex(i => i.type === state.type);
      if (idx > -1) {
        this._history = this._history.slice(0, idx + 1);
      } else {
        state.useHistory = true;
        this._history.push(state);
      }
    } else {
      this._history = [];
    }
  }

  @Mutation
  resetItems() {
    this._type = SidebarType.None;
    this._item = {};
    this._title = "";
    this._options = {};
    this._history = [];
    this._snapshotDisabled = false;
    this._size = "";
  }

  @Mutation
  setSidebarItem(item: SidebarState["item"]) {
    this._item = item;
  }

  @Mutation
  setSidebarOptions(options: SidebarState["options"]) {
    this._options = options;
  }

  @Mutation
  setSidebarSize(size: SidebarState["size"]) {
    this._size = size;
  }

  @Mutation
  resetHistory() {
    this._history = [];
  }

  @Mutation
  setSnapshotDisabled(value: boolean) {
    this._snapshotDisabled = value;
  }

  @Action({ rawError: true })
  reset() {
    this.context.commit("setSidebarState", {
      type: SidebarType.None,
      item: {},
      title: "",
      options: {}
    });
  }

  get type() {
    return this._type;
  }

  get item() {
    return this._item;
  }

  get title() {
    return this._title;
  }

  get options() {
    return this._options;
  }

  get size() {
    return this._size;
  }

  get curState() {
    return this._history[this._history.length - 1];
  }

  get prevState() {
    return this._history[this._history.length - 2];
  }

  get snapshotDisabled() {
    return this._snapshotDisabled;
  }

  @Action({ rawError: true })
  resetState() {
    this.context.commit("resetItems");
  }
}

export default SidebarModule;